import { render, staticRenderFns } from "./AddressBookDetail.vue?vue&type=template&id=0ddecd4a"
import script from "./AddressBookDetail.vue?vue&type=script&lang=js"
export * from "./AddressBookDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports